module.exports = __webpack_public_path__ + "img/3.70915a66.png";